export default __webpack_public_path__ + "static/media/step.44709a92.svg";